const MAX_ENTRIES = 2000;
/** Capture the caller stack, excluding this recorder's implementation frames. */
function captureDiagnosticTrace() {
    const stack = new Error().stack;
    if (!stack) {
        return null;
    }
    return stack.split('\n').slice(2).join('\n');
}
function getDiagnosticsState() {
    const diagnosticsAllowed = window.isDevelopment?.() || window.isTestMode?.() || window.isTest?.();
    if (!diagnosticsAllowed) {
        return null;
    }
    if (!window.__liveTextDiagnostics) {
        window.__liveTextDiagnostics = {
            enabled: true,
            entries: []
        };
    }
    return window.__liveTextDiagnostics?.enabled
        ? window.__liveTextDiagnostics
        : null;
}
/** Record a compact text-layout snapshot and caller trace when diagnostics are on. */
export function recordLiveTextDiagnostic(source, textRunEditor, detail = {}) {
    const state = getDiagnosticsState();
    if (!state) {
        return;
    }
    let cumulativeX = 0;
    const glyphs = (textRunEditor?.shapedGlyphs || []).map((glyph, index) => {
        const ax = Number.isFinite(glyph.ax) ? glyph.ax : 0;
        const snapshot = {
            index,
            name: glyph.explicitGlyphName ||
                textRunEditor?.glyphNameBuffer?.[index] ||
                null,
            ax,
            dx: Number.isFinite(glyph.dx) ? glyph.dx : 0,
            cumulativeX
        };
        cumulativeX += ax;
        return snapshot;
    });
    const entries = state.entries;
    const entry = {
        sequence: (entries[entries.length - 1]?.sequence || 0) + 1,
        timestamp: performance.now(),
        source,
        trace: captureDiagnosticTrace(),
        text: textRunEditor?.textBuffer || '',
        selectedGlyphIndex: textRunEditor?.selectedGlyphIndex ?? -1,
        glyphs,
        totalAdvance: cumulativeX,
        detail
    };
    entries.push(entry);
    if (entries.length > MAX_ENTRIES) {
        entries.splice(0, entries.length - MAX_ENTRIES);
    }
    window.dispatchEvent(new CustomEvent('liveTextDiagnosticsRecorded', { detail: entry }));
}
